import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Puneairportcab() {



    const cardData = {

keyword: "Pune Airport Cabs",

headingDescription:
    "Rising Cab Service offers reliable and affordable Pune Airport Cabs for airport transfers, local travel, business trips, and outstation journeys. We provide timely airport pickup and drop services with well-maintained Sedan, SUV, Innova Crysta, Tempo Traveller, and Urbania vehicles driven by professional chauffeurs. Our service is available 24/7 with flight tracking, transparent pricing, and doorstep pickup to ensure a comfortable and hassle-free travel experience to and from Pune Airport.",

topPlaces: [
    {
        title: "Mumbai Airport",
        description:
            "Mumbai Airport is one of India's busiest international airports and a popular destination from Pune for domestic and international travelers. Many passengers prefer comfortable cab services for seamless airport transfers."
    },
    {
        title: "Shirdi",
        description:
            "Shirdi is a major pilgrimage destination for Sai Baba devotees. Travelers arriving at Pune Airport often book cabs directly to Shirdi for convenient and comfortable darshan trips."
    },
    {
        title: "Lonavala",
        description:
            "Lonavala is a scenic hill station near Pune known for waterfalls, green valleys, Tiger Point, and Bhushi Dam. It is a favorite destination for tourists landing at Pune Airport."
    },
    {
        title: "Mahabaleshwar",
        description:
            "Mahabaleshwar is a beautiful hill station famous for strawberry farms, Venna Lake, and breathtaking viewpoints. Airport travelers often choose cab services for a relaxing holiday journey."
    },
    {
        title: "Goa",
        description:
            "Goa is one of India's top tourist destinations, known for beaches, nightlife, churches, and water sports. Pune Airport serves as a convenient starting point for road trips to Goa."
    },
    {
        title: "Nashik",
        description:
            "Nashik is a popular spiritual and wine tourism destination featuring Trimbakeshwar Jyotirlinga, Panchvati, and renowned vineyards. Airport cab services provide easy access for travelers."
    },
    {
        title: "Bhimashankar",
        description:
            "Bhimashankar is one of the twelve Jyotirlingas and a popular pilgrimage destination surrounded by the Sahyadri hills, attracting devotees and nature enthusiasts alike."
    },
    {
        title: "Aurangabad",
        description:
            "Aurangabad is famous for Ajanta and Ellora Caves, Bibi Ka Maqbara, and Daulatabad Fort. It is a preferred heritage destination for tourists arriving in Pune."
    },
    {
        title: "Kolhapur",
        description:
            "Kolhapur is known for the Mahalakshmi Temple, Panhala Fort, and rich cultural heritage. It is a frequently booked outstation route from Pune Airport."
    },
    {
        title: "Alibaug",
        description:
            "Alibaug is a peaceful coastal destination famous for its beaches, sea forts, and weekend getaways. Many travelers choose Pune Airport cabs for a comfortable journey to Alibaug."
    }
],



services: [
    {
        name: "Pune Airport Cab",
        description:
            "Rising Cab Service offers Pune Airport Cab services for comfortable and hassle-free airport transportation. Whether you need a pickup or drop at Pune International Airport, our professional drivers ensure timely arrivals and departures with clean AC vehicles. We provide 24x7 airport cab services for individuals, families, tourists, and corporate travelers with transparent pricing and convenient online booking."
    },
    {
        name: "Airport Taxi Pune",
        description:
            "Our Airport Taxi Pune service provides reliable transportation to and from Pune Airport with punctual pickups and comfortable rides. Rising Cab Service offers hatchbacks, sedans, SUVs, Innova Crysta, and premium vehicles suitable for business travel, family trips, and airport transfers at affordable rates."
    },
    {
        name: "Pune Airport Pickup Drop",
        description:
            "Rising Cab Service provides Pune Airport Pickup Drop services with professional chauffeurs and well-maintained vehicles. We monitor flight schedules to ensure timely pickups and drops, making airport travel smooth and stress-free for passengers."
    },
    {
        name: "Cab to Pune Airport",
        description:
            "Book a Cab to Pune Airport with Rising Cab Service for safe and timely airport transfers. Our 24x7 service ensures comfortable travel from any location in Pune with affordable fares and experienced drivers."
    },
    {
        name: "Cab from Pune Airport",
        description:
            "Our Cab from Pune Airport service offers convenient transportation from the airport to any destination in Pune or nearby cities. We provide instant booking, professional drivers, and comfortable vehicles for a pleasant journey."
    },
    {
        name: "Pune Airport Taxi Booking",
        description:
            "Rising Cab Service offers Pune Airport Taxi Booking with quick confirmation and multiple vehicle options. Whether you need an immediate ride or an advance reservation, our airport taxi service ensures reliable transportation."
    },
    {
        name: "Airport Transfer Pune",
        description:
            "Our Airport Transfer Pune service provides seamless transportation between Pune Airport and hotels, offices, homes, and outstation destinations with punctual service and comfortable vehicles."
    },
    {
        name: "24x7 Airport Cab Pune",
        description:
            "Rising Cab Service provides 24x7 Airport Cab Pune for early morning flights, late-night arrivals, and emergency travel requirements. Our round-the-clock service ensures dependable airport transportation anytime."
    },
    {
        name: "Cheap Airport Cab Pune",
        description:
            "Book Cheap Airport Cab Pune with Rising Cab Service for affordable airport transportation without compromising comfort or reliability. Our budget-friendly pricing suits all travel needs."
    },
    {
        name: "Luxury Airport Cab Pune",
        description:
            "Our Luxury Airport Cab Pune service offers premium vehicles and professional chauffeurs for business executives, VIP guests, and travelers seeking high-end airport transportation."
    },
    {
        name: "Pune Airport Shuttle Taxi",
        description:
            "Rising Cab Service provides Pune Airport Shuttle Taxi solutions for individuals and groups requiring convenient and economical airport travel with comfortable seating and dependable service."
    },
    {
        name: "Reliable Airport Taxi Pune",
        description:
            "Our Reliable Airport Taxi Pune ensures punctual pickups, safe driving, and professional service for airport transfers with experienced drivers and clean vehicles."
    },
    {
        name: "Private Airport Cab Pune",
        description:
            "Rising Cab Service offers Private Airport Cab Pune for passengers seeking exclusive and comfortable airport transportation with complete privacy and personalized service."
    },
    {
        name: "Pune Airport Cab Fare",
        description:
            "Get transparent Pune Airport Cab Fare with Rising Cab Service. Our pricing is fair and competitive with no hidden charges for airport pickups and drops."
    },
    {
        name: "Sedan Airport Cab Pune",
        description:
            "Our Sedan Airport Cab Pune service provides comfortable and affordable airport transfers for individuals and small families with spacious and air-conditioned vehicles."
    },
    {
        name: "Pune to Mumbai Airport Cab Fare",
        description:
            "Rising Cab Service offers Pune to Mumbai Airport Cab Fare with affordable pricing for one-way and round-trip airport transfers to Mumbai International Airport."
    },
    {
        name: "Pune Airport to Shirdi Distance Taxi Fare",
        description:
            "Our Pune Airport to Shirdi Distance Taxi Fare service provides direct airport pickup and comfortable travel to Shirdi with transparent pricing and experienced drivers."
    },
    {
        name: "Pune Airport Cab Service",
        description:
            "Rising Cab Service provides Pune Airport Cab Service for airport pickups, drops, corporate travel, and family transportation with 24x7 availability."
    },
    {
        name: "Pune to Mumbai Airport Cab",
        description:
            "Book Pune to Mumbai Airport Cab with Rising Cab Service for safe and comfortable long-distance airport transfers with professional chauffeurs."
    },
    {
        name: "Pune to Shirdi Cab One Way",
        description:
            "Our Pune to Shirdi Cab One Way service offers economical and convenient travel for pilgrims with comfortable vehicles and experienced drivers."
    },
    {
        name: "Pune to Mumbai Airport",
        description:
            "Rising Cab Service provides Pune to Mumbai Airport transportation with timely pickups and flexible booking options for stress-free travel."
    },
    {
        name: "Pune Mumbai Airport Drop",
        description:
            "Our Pune Mumbai Airport Drop service ensures punctual and comfortable transfers to Mumbai Airport with affordable pricing and reliable drivers."
    },
    {
        name: "Pune Airport Taxi",
        description:
            "Rising Cab Service offers Pune Airport Taxi services for local and outstation passengers requiring safe, affordable, and dependable airport transportation."
    },
    {
        name: "Outstation Car Rental Pune",
        description:
            "Our Outstation Car Rental Pune provides comfortable vehicles for long-distance travel from Pune Airport and city locations to destinations across Maharashtra and India."
    },
    {
        name: "Airport Cabs Pune",
        description:
            "Rising Cab Service provides Airport Cabs Pune with reliable pickup and drop services, professional drivers, and affordable rates for all passengers."
    },
    {
        name: "Pune Airport Cabs",
        description:
            "Book Pune Airport Cabs with Rising Cab Service for convenient airport transportation with multiple vehicle options and 24x7 availability."
    },
    {
        name: "Pune Airport Taxi Service",
        description:
            "Our Pune Airport Taxi Service ensures timely airport transfers with clean vehicles, trained drivers, and competitive pricing."
    },
    {
        name: "Pune Airport Cab Booking",
        description:
            "Rising Cab Service offers Pune Airport Cab Booking with instant confirmation and flexible scheduling for airport travel requirements."
    },
    {
        name: "Airport Cab Service Pune",
        description:
            "Our Airport Cab Service Pune provides dependable airport transportation for local residents, tourists, and business travelers with affordable pricing."
    },
    {
        name: "Pune Airport Pickup and Drop",
        description:
            "Rising Cab Service provides Pune Airport Pickup and Drop with timely service, comfortable vehicles, and experienced chauffeurs for stress-free airport travel."
    },
    {
        name: "24x7 Pune Airport Cab",
        description:
            "Our 24x7 Pune Airport Cab service is available round the clock for early morning departures, late-night arrivals, and emergency airport transportation."
    },
    {
        name: "Cheap Pune Airport Taxi",
        description:
            "Book Cheap Pune Airport Taxi with Rising Cab Service for affordable airport transfers with reliable drivers and comfortable AC vehicles."
    },
    {
        name: "Online Pune Airport Cab Booking",
        description:
            "Rising Cab Service offers Online Pune Airport Cab Booking with instant confirmation, transparent pricing, and convenient reservation options."
    },
    {
        name: "Best Airport Cab Service Pune",
        description:
            "Our Best Airport Cab Service Pune combines safety, punctuality, affordable pricing, and professional drivers to provide an exceptional airport travel experience."
    },
    {
        name: "Pune Airport Transfer Service",
        description:
            "Rising Cab Service provides Pune Airport Transfer Service for individuals, families, tourists, and corporate clients with reliable and comfortable transportation."
    },
    {
        name: "Best Cab Service Near Pune Airport",
        description:
            "Looking for the Best Cab Service Near Pune Airport? Rising Cab Service offers quick pickups, affordable fares, and dependable airport transportation with multiple vehicle options."
    },
    {
        name: "Book Airport Cab Online Pune",
        description:
            "Book Airport Cab Online Pune with Rising Cab Service for instant reservations, transparent pricing, and 24x7 airport transportation backed by professional customer support."
    }
],

tableData: [
    ["Pune Airport Cab", "Airport Taxi Pune"],
    ["Pune Airport Pickup Drop", "Cab to Pune Airport"],
    ["Cab from Pune Airport", "Pune Airport Taxi Booking"],
    ["Airport Transfer Pune", "24x7 Airport Cab Pune"],
    ["Cheap Airport Cab Pune", "Luxury Airport Cab Pune"],
    ["Pune Airport Shuttle Taxi", "Reliable Airport Taxi Pune"],
    ["Private Airport Cab Pune", "Pune Airport Cab Fare"],
    ["Sedan Airport Cab Pune", "Pune to Mumbai Airport Cab Fare"],
    ["Pune Airport to Shirdi Distance Taxi Fare", "Pune Airport Cab Service"],
    ["Pune to Mumbai Airport Cab", "Pune to Shirdi Cab One Way"],
    ["Pune to Mumbai Airport", "Pune Mumbai Airport Drop"],
    ["Pune Airport Taxi", "Outstation Car Rental Pune"],
    ["Airport Cabs Pune", "Pune Airport Cabs"],
    ["Pune Airport Taxi Service", "Pune Airport Cab Booking"],
    ["Airport Cab Service Pune", "Pune Airport Pickup and Drop"],
    ["24x7 Pune Airport Cab", "Cheap Pune Airport Taxi"],
    ["Online Pune Airport Cab Booking", "Best Airport Cab Service Pune"],
    ["Pune Airport Transfer Service", "Best Cab Service Near Pune Airport"],
    ["Book Airport Cab Online Pune", "Pune Airport Cab"]
],




whychoose: [
    {
        WhyChooseheading: "Quick Airport Transfers Across Pune",
        WhyChoosedescription: "Rising Cab Service provides reliable Pune Airport cab services for business travelers, tourists, families, students, and frequent flyers requiring timely airport transportation."
    },
    {
        WhyChooseheading: "Timely Pickup for Every Flight Schedule",
        WhyChoosedescription: "Whether you have an early morning departure or a late-night arrival, our airport cabs are available to match your flight timing."
    },
    {
        WhyChooseheading: "Direct Airport Pickup and Drop Service",
        WhyChoosedescription: "Enjoy hassle-free transportation between Pune Airport and homes, hotels, offices, railway stations, and nearby cities with professional drivers."
    },
    {
        WhyChooseheading: "Vehicle Options for Solo and Group Travelers",
        WhyChoosedescription: "Choose from Sedan cars, Ertiga, Innova Crysta, SUVs, Tempo Travellers, and larger vehicles depending on passenger count and luggage requirements."
    },
    {
        WhyChooseheading: "Airport Travel with Real-Time Coordination",
        WhyChoosedescription: "Our team monitors travel schedules and coordinates pickups efficiently to help reduce waiting time and travel stress."
    },
    {
        WhyChooseheading: "Serving Pune and PCMC Locations",
        WhyChoosedescription: "Airport cab services are available from Baner, Wakad, Hinjewadi, Kharadi, Hadapsar, Kothrud, Wagholi, Pimpri Chinchwad, and surrounding areas."
    },
    {
        WhyChooseheading: "Comfortable Rides for Business Travelers",
        WhyChoosedescription: "Corporate professionals frequently choose our airport cabs for comfortable, convenient, and dependable transportation."
    },
    {
        WhyChooseheading: "Travel Solutions Available Throughout the Year",
        WhyChoosedescription: "Rising Cab Service operates airport transportation services during weekends, holidays, festive seasons, and peak travel periods."
    }
]
};

const faqData = [
    {
        question: "How far in advance should airport transportation be reserved?",
        answer: "Advance booking is recommended, especially during holidays, weekends, and peak travel periods."
    },
    {
        question: "Can airport pickups be arranged for arriving passengers?",
        answer: "Yes, pickup services are available for domestic and international flight arrivals."
    },
    {
        question: "Which Pune locations are covered for airport transfers?",
        answer: "Our services cover all major Pune and PCMC areas including Baner, Wakad, Hinjewadi, Kharadi, Hadapsar, Viman Nagar, and Kothrud."
    },
    {
        question: "Are larger vehicles available for travelers carrying extra luggage?",
        answer: "Yes, spacious vehicles such as Ertiga, Innova Crysta, SUVs, and Tempo Travellers can be arranged."
    },
    {
        question: "Can corporate travelers schedule regular airport transportation?",
        answer: "Yes, airport transfer services are frequently used by executives, business visitors, and corporate teams."
    },
    {
        question: "Is transportation available during late-night flight schedules?",
        answer: "Yes, airport cab services can be scheduled according to flight departure and arrival timings."
    },
    {
        question: "Do families frequently use airport cab services?",
        answer: "Yes, families often choose airport cabs for comfortable travel with luggage and children."
    },
    {
        question: "Can outstation travelers directly travel from Pune Airport to another city?",
        answer: "Yes, airport pickups can be combined with outstation travel plans to various destinations."
    },
    {
        question: "What vehicle options are most popular for airport transfers?",
        answer: "Sedan cars, Ertiga, and Innova Crysta are among the most preferred options for airport transportation."
    },
    {
        question: "How can customers arrange a Pune Airport Cab?",
        answer: "Bookings can be confirmed through phone calls, WhatsApp messages, or online inquiries with Rising Cab Service."
    }
];

const testimonials = [
    {
        id: 1,
        name: "Mr. Sandeep Kulkarni",
        feedback:
            "Catching an early morning flight became completely stress-free with Rising Cab Service. The driver arrived before time, and the journey to the airport was smooth and comfortable.",
        rating: 5
    },
    {
        id: 2,
        name: "Mrs. Rutuja Patil",
        feedback:
            "After returning from a late-night flight, the airport pickup was already waiting as scheduled. The entire experience was professional, convenient, and highly dependable.",
        rating: 5
    }
];









    const Images = [
        { place: "/images/keyword/1.jpg", text: "Pune Darshan Cab", link: "Pune-Darshan-Cab" },
        { place: "/images/keyword/2.jpg", text: "Pune to Bhimashankar Cab", link: "Pune-to-Bhimashankar-Cab" },
        { place: "/images/keyword/3.jpg", text: "Pimpri Chinchwad to Bhimashankar Cab", link: "Pimpri-Chinchwad-to-Bhimashankar-Cab" },
        { place: "/images/keyword/4.jpg", text: "Pune to Jejuri Cab", link: "Pune-to-Jejuri-Cab" },
        { place: "/images/keyword/5.jpg", text: "Pune Weekend Tour Packages", link: "Pune-Weekend-Tour-Packages" },
        { place: "/images/keyword/6.jpg", text: "Pune Darshan Packages", link: "Pune-Darshan-Packages" },
        { place: "/images/keyword/7.jpg", text: "Pune Sade Teen Shakti Peeth Bus on Rent", link: "Pune-Sade-Teen-Shakti-Peeth-Bus-on-Rent" },
        { place: "/images/keyword/8.jpg", text: "Pune Darshan Tempo Traveller on Rent", link: "Pune-Darshan-Tempo-Traveller-on-Rent" },
        { place: "/images/keyword/9.jpg", text: "Pune to Mysore Ooty Cab Package", link: "Pune-to-Mysore-Ooty-Cab-Package" },
        { place: "/images/keyword/10.jpg", text: "Pune to Mumbai Darshan Package", link: "Pune-to-Mumbai-Darshan-Package" },
        { place: "/images/keyword/11.jpg", text: "Pune to Ajanta Ellora Cab Service", link: "Pune-to-Ajanta-Ellora-Cab-Service" },
        { place: "/images/keyword/12.jpg", text: "Pune to Shirdi Darshan Package", link: "Pune-to-Shirdi-Darshan-Package" },
        { place: "/images/keyword/13.jpg", text: "Pune to Pandharpur Darshan", link: "Pune-to-Pandharpur-Darshan" },
        { place: "/images/keyword/14.jpg", text: "Hinjewadi Cab Service", link: "Hinjewadi-Cab-Service" },
        { place: "/images/keyword/15.jpg", text: "Cab Service in Wakad", link: "Cab-Service-in-Wakad" },
        { place: "/images/keyword/16.jpg", text: "Cab Service in Baner Pune", link: "Cab-Service-in-Baner-Pune" },
        { place: "/images/keyword/17.jpg", text: "Cab Service in Kharadi", link: "Cab-Service-in-Kharadi" },
        { place: "/images/keyword/18.jpg", text: "Cab Service in Hadapsar", link: "Cab-Service-in-Hadapsar" },
        { place: "/images/keyword/19.jpg", text: "Cab Service in Viman Nagar", link: "Cab-Service-in-Viman-Nagar" },
        { place: "/images/keyword/20.jpg", text: "Cab Service in Kothrud", link: "Cab-Service-in-Kothrud" },
        { place: "/images/keyword/21.jpg", text: "Cab Service in Pimpri Chinchwad", link: "Cab-Service-in-Pimpri-Chinchwad" },
        { place: "/images/keyword/22.jpg", text: "Cab Service in Wagholi Pune", link: "Cab-Service-in-Wagholi-Pune" },
        { place: "/images/keyword/23.jpg", text: "Pune to Trimbakeshwar Cab", link: "Pune-to-Trimbakeshwar-Cab" },
        { place: "/images/keyword/24.jpg", text: "Cab Service in Pune", link: "Cab-Service-in-Pune" },
        { place: "/images/keyword/25.jpg", text: "Outstation Taxi Service Pune", link: "Outstation-Taxi-Service-Pune" },
    ];












const productSchema = {
"@context": "https://schema.org",
"@type": "Product",
"name": "Pune Airport Cab Service",
"image": "https://www.risingcabservice.com/assets/images/pune-airport-cab-service.jpg",
"description": "Book Pune Airport Cab Service with Rising Cab Service for reliable pickup and drop, 24x7 airport transfers, and outstation travel. Enjoy safe, affordable, and comfortable taxi service to and from Pune Airport with professional drivers.",
"brand": {
"@type": "Brand",
"name": "Rising Cab Service"
},
"aggregateRating": {
"@type": "AggregateRating",
"bestRating": "5",
"worstRating": "1",
"ratingValue": "4.8",
"ratingCount": "5471"
},
"offers": {
"@type": "Offer",
"priceCurrency": "INR",
"price": "Starting From ₹14/Km",
"availability": "https://schema.org/InStock",
"url": "https://www.risingcabservice.com/pune-airport-cabs"
}
};






    return (
        <div>

<Helmet>
  <title>Pune Airport Cab Service | 24x7 Pickup & Drop Taxi | +91 9272511548</title>

<meta
 name="description"
 content="Book Pune Airport Cab Service for 24x7 pickup and drop, airport transfers, and outstation travel. Reliable, affordable, and comfortable taxi service to and from Pune Airport."
/>

<meta
 name="keywords"
 content="Pune airport cab, airport taxi pune, pune airport pickup drop, cab to pune airport, cab from pune airport, pune airport taxi booking, airport transfer pune, 24x7 airport cab pune, cheap airport cab pune, luxury airport cab pune, pune airport shuttle taxi, reliable airport taxi pune, private airport cab pune, pune airport cab fare, sedan airport cab pune, Pune to mumbai airport cab fare, Pune airport to shirdi distance taxi fare, Pune airport cab service, pune to mumbai airport cab, pune to shirdi cab one way, Pune mumbai airport drop, Pune airport taxi, Outstation car rental pune"
/>

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>

</Helmet>


            <div
                className="breadcumb-wrapper"
                style={{
                    backgroundImage: "url('./img/bg/breadcrumb-bg.jpg')",
                    position: "relative",
                }}
            >
                <div
                    style={{
                        position: "absolute",
                        inset: 0,
                        backgroundColor: "rgba(0,0,0,0.3)",
                        zIndex: 1,
                    }}></div>

                <div className="container" style={{ position: "relative", zIndex: 2 }}>
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title"> {cardData.keyword}</h1>
                    </div>
                </div>
            </div>




















            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/29.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#FF681A', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Rising Cab Service: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>


                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">
                                        {/* <div className="service-icon">
                      🚗
                    </div> */}
                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title text-white">
                                    Why Choose <span>Rising Cab Service</span>
                                </h2>


                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Rising Cab Service </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919272511548" className="pc-call">+91 9272511548</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919272511548"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919272511548" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@risingcabservice.com" className="pc-email">
                                            booking@risingcabservice.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-geo-alt-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Rising Cab Service</strong><br />

                                            A Unit of Atithya Dining LLP,
                                            901, 902 Deron Height, Baner Rd,
                                            Above Ranka Jewelers, Pune,
                                            Maharashtra -411069
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Puneairportcab;